import { Injectable, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuncaoService, LoginContabil, Exercicio, Relatorio, GlobalService } from 'eddydata-lib';
import { BalancoService } from '../service/balanco.service';

@Injectable({
  providedIn: 'root'
})
export class Anexo14Balanco implements OnDestroy {
  protected funcaoService: FuncaoService;
  private login: LoginContabil = new LoginContabil();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected anexoServico: BalancoService) {
    this.funcaoService = new FuncaoService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // tslint:disable: max-line-length
  public montarRelatorio(exercicio: Exercicio, orgaos: number[]) {
    this.anexoServico.obterBalancoPatrimonial(exercicio.id, orgaos)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {

        Relatorio.imprimirPersonalizado(
          'ANEXO 14 - BALANÇO PATRIMONIAL'
          , this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.conteudo(dados, exercicio),
          'portrait', 'ANEXO 14 - BALANÇO PATRIMONIAL',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, false, true);
      });
  }

  private conteudo(dados: any, exercicio: Exercicio): {}[] {

    // monta o cabecalho
    const registros: {}[] = [
      [{
        text: `EXERCÍCIO ${exercicio.ano}`, fontSize: 13,
        alignment: 'center', bold: true, colSpan: 6, border: [true, true, true, false]
      }, '', '', '', '', ''],
      [{
        text: `${this.login.orgao.especie === 'C' ? 'PODER LEGISLATIVO' : 'PODER EXECUTIVO'}`,
        alignment: 'center',
        bold: true,
        colSpan: 6, border: [true, false, true, false]
      }, '', '', '', '', ''],
      [{
        text: 'TÍTULOS',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'EXERCÍCIO ATUAL',
        alignment: 'center',
        bold: true, fontSize: 8,
      }, {
        text: 'EXERCÍCIO ANTERIOR',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'TÍTULOS',
        alignment: 'center',
        bold: true, fontSize: 8
      }, {
        text: 'EXERCÍCIO ATUAL',
        alignment: 'center',
        bold: true, fontSize: 8,
      }, {
        text: 'EXERCÍCIO ANTERIOR',
        alignment: 'center',
        bold: true, fontSize: 8
      }]
    ];

    // monta o agrupamento do relatório
    const grupos1 = this.funcaoService.agrupar(dados[0], 'grupo',
      ['valor_atual', 'valor_anterior']);
    const grupos2 = this.funcaoService.agrupar(dados[1], 'grupo',
      ['valor_atual', 'valor_anterior']);
    const totalizador = new Array<any>();
    let totalGrupos = grupos1.length + grupos2.length;
    let total1 = 0;
    let total2 = 0;
    let total3 = 0;
    let total4 = 0;
    for (let index = 0; index < totalGrupos; index++) {
      const item1 = grupos1[index];
      const item2 = grupos2[index];

        registros.push([
          {
            text: item1 ? item1.grupo : '', bold: true, fontSize: 8, border: [true, false, false, false]
          },
          {
            text: item1 ? this.funcaoService.convertToBrNumber(item1.totalizadores[`valor_atual`]) : '', alignment: 'right',
            bold: true, fontSize: 8, border: [true, false, false, false]
          },
          {
            text: item1 ? this.funcaoService.convertToBrNumber(item1.totalizadores[`valor_anterior`]) : '', alignment: 'right',
            bold: true, fontSize: 8, border: [true, false, false, false]
          },
          {
            text: item2 ? item2.grupo : '', bold: true, fontSize: 8, border: [true, false, false, false]
          },
          {
            text: item2 ? this.funcaoService.convertToBrNumber(item2.totalizadores[`valor_atual`]) : '', alignment: 'right',
            bold: true, fontSize: 8, border: [true, false, true, false]
          },
          {
            text: item2 ? this.funcaoService.convertToBrNumber(item2.totalizadores[`valor_anterior`]) : '', alignment: 'right',
            bold: true, fontSize: 8, border: [true, false, true, false]
          }
        ]);

        // lista os registros do relatorio
        const totalRegistro = (item1 ? item1.registros.length : 0) + (item2 ? item2.registros.length : 0);
        for (let idx = 0; idx < totalRegistro; idx++) {
          const element1 = item1 ? item1.registros[idx] : null;
          const element2 = item2 ? item2.registros[idx] : null;
          registros.push([
            {
              text: element1 && element1.nome !== '' ? `${element1 ? element1.nome : ''}` : '', fontSize: 8, border: [true, false, false, false]
            },
            {
              text: element1 && element1.nome !== '' ? this.funcaoService.convertToBrNumber(element1.valor_atual) : '', alignment: 'right',
              fontSize: 8, border: [true, false, false, false]
            },
            {
              text: element1 && element1.nome !== '' ? this.funcaoService.convertToBrNumber(element1.valor_anterior) : '', alignment: 'right',
              fontSize: 8, border: [true, false, false, false]
            },
            {
              text: element2 && element2.nome !== '' ? `${element2 ? element2.nome : ''}` : '', fontSize: 8, border: [true, false, false, false]
            },
            {
              text: element2 && element2.nome !== '' ? this.funcaoService.convertToBrNumber(element2.valor_atual) : '', alignment: 'right',
              fontSize: 8, border: [true, false, false, false]
            },
            {
              text: element2 && element2.nome !== '' ? this.funcaoService.convertToBrNumber(element2.valor_anterior) : '', alignment: 'right',
              fontSize: 8, border: [true, false, true, false]
            }
          ]);

        }
        total1 += item1 ? +item1.totalizadores['valor_atual'] : 0;
        total2 += item1 ? +item1.totalizadores['valor_anterior'] : 0;
        total3 += item2 ? +item2.totalizadores['valor_atual'] : 0;
        total4 += item2 ? +item2.totalizadores['valor_anterior'] : 0;
        totalizador.push({
          col1: item1 ? item1.grupo : '',
          col2: item1 ? item1.totalizadores['valor_atual'] : 0,
          col3: item1 ? item1.totalizadores['valor_anterior'] : 0,
          col4: item2 ? item2.grupo : '',
          col5: item2 ? item2.totalizadores['valor_atual'] : 0,
          col6: item2 ? item2.totalizadores['valor_anterior'] : 0,
        });
    }


    registros.push([{
      text: 'TOTAL', border: [true, true, true, true], fontSize: 8, bold: true
    },
    {
      text: this.funcaoService.convertToBrNumber(total1), alignment: 'right',
      border: [true, true, true, true], fontSize: 8, bold: true
    },
    {
      text: this.funcaoService.convertToBrNumber(total2), alignment: 'right',
      border: [true, true, true, true], fontSize: 8, bold: true
    },
    {
      text: 'TOTAL', border: [true, true, false, true], fontSize: 8, bold: true
    },
    {
      text: this.funcaoService.convertToBrNumber(total3), alignment: 'right',
      border: [true, true, true, true], fontSize: 8, bold: true
    },
    {
      text: this.funcaoService.convertToBrNumber(total4), alignment: 'right',
      border: [true, true, true, true], fontSize: 8, bold: true
    }]);

    registros.push([{
      text: '', colSpan: 6, border: [true, true, true, false]
    }, '', '', '', '', '']);

    registros.push([{
      text: 'RESUMO', alignment: 'center', colSpan: 6, border: [true, false, true, true]
    }, '', '', '', '', '']);
    const grupos3 = this.funcaoService.agrupar(dados[2], 'grupo',
      ['valor_atual', 'valor_anterior']);
    const grupos4 = this.funcaoService.agrupar(dados[3], 'grupo',
      ['valor_atual', 'valor_anterior']);
    totalGrupos = +grupos3.length + +grupos4.length;
    for (let index = 0; index < totalGrupos; index++) {
      const item1 = grupos3[index];
      const item2 = grupos4[index];
      registros.push([
        {
          text: item1 ? item1.grupo : '', bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item1 ? this.funcaoService.convertToBrNumber(item1.totalizadores[`valor_atual`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item1 ? this.funcaoService.convertToBrNumber(item1.totalizadores[`valor_anterior`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item2 ? item2.grupo : '', bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item2 ? this.funcaoService.convertToBrNumber(item2.totalizadores[`valor_atual`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, true, false]
        },
        {
          text: item2 ? this.funcaoService.convertToBrNumber(item2.totalizadores[`valor_anterior`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, true, false]
        }
      ]);
    }

    registros.push([{
      text: '', alignment: 'center', colSpan: 6, border: [false, true, false, false], margin: [10, 10, 10, 10]
    }, '', '', '', '', '']);

    registros.push([{
      text: 'QUADRO DAS CONTAS DE COMPENSAÇÃO', alignment: 'center', colSpan: 6, border: [true, true, true, false]
    }, '', '', '', '', '']);
    registros.push([{
      text: 'Atos Potenciais Ativo', alignment: 'center', border: [true, true, true, true]
    }, '', '', 'Atos Potenciais Passivo', '', '']);
    totalGrupos = +dados[4].length + +dados[5].length;
    for (let index = 0; index < totalGrupos; index++) {
      const item1 = dados[4][index];
      const item2 = dados[5][index];
      registros.push([
        {
          text: item1 ? item1.nome : '', bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item1 ? this.funcaoService.convertToBrNumber(item1[`valor_atual`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item1 ? this.funcaoService.convertToBrNumber(item1[`valor_anterior`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item2 ? item2.nome : '', bold: true, fontSize: 8, border: [true, false, false, false]
        },
        {
          text: item2 ? this.funcaoService.convertToBrNumber(item2[`valor_atual`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, true, false]
        },
        {
          text: item2 ? this.funcaoService.convertToBrNumber(item2[`valor_anterior`]) : '', alignment: 'right',
          bold: true, fontSize: 8, border: [true, false, true, false]
        }
      ]);
    }

    registros.push([{
      text: '', alignment: 'center', colSpan: 6, border: [false, true, false, false]
    }, '', '', '', '', '']);

    return [{
      layout: 'linhas',
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        dontBreakRows: true,
        headerRows: 0,
        widths: ['*', 'auto', 'auto', '*', 'auto', 'auto'],
        body: registros
      }
    }];
  }


}
